import { Heading } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledHeading = styled(Heading)`
  margin-bottom: ${rem('16px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('24px')};
  }
`;

export const StyledSection = styled.section`
  width: 100%;
  margin: ${rem('40px')} 0;
`;

export const StyledCardsWrapper = styled.div`
  display: flex;
  gap: ${rem('32px')};
  margin: ${rem('56px')} 0;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    flex-wrap: wrap;
  }
`;

export const StyledCard = styled.article`
  border: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  border-radius: ${rem('16px')};
  padding: ${rem('32px')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem('16px')};

  & * {
    margin: 0;
  }

  & *:last-child {
    margin-top: ${rem('12px')};
  }
`;

export const StyledForm = styled.form`
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  border-radius: ${rem('16px')};
  padding: ${rem('32px')};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${rem('48px')};

  & * {
    margin: 0;
  }

  & > *:not(button) {
    width: 100%;
  }
`;

export const StyledRadioButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem('8px')};
  margin-top: ${rem('4px')};
`;

export const StyledFieldset = styled.fieldset`
  border: 0;
  padding: 0;
  margin: 0;

  display: flex;
  flex-wrap: wrap;
  gap: ${rem('32px')};

  & > * {
    margin: 0;
    flex: 0 1 calc(50% - ${rem('16px')});
  }

  & > *:first-child {
    flex: 1 0 100%;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    & > * {
      flex: 1 1 100%;
    }
  }
`;

export const StyledField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
`;

export const StyledInput = styled.input`
  border: none;
  outline: none;
  background-color: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  padding: ${rem('12px')} 0;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${({ theme }) => theme.colors.cross.grayson};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.colors.cross.grayson};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ theme }) => theme.colors.cross.grayson};
  }
`;

export const StyledSelect = styled.select<{ isPlaceholderActive: boolean }>`
  border: none;
  outline: none;
  background-color: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  padding: ${rem('12px')} 0;
  width: 100%;

  color: ${({ theme, isPlaceholderActive }) =>
    isPlaceholderActive && theme.colors.cross.grayson};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const StyledTextArea = styled.textarea`
  border: none;
  outline: none;
  background-color: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  padding: ${rem('12px')} 0;
  resize: none;
`;

export const StyledError = styled.span<{ big?: boolean }>`
  color: ${({ theme }) => theme.colors.cross.red};
  font-size: ${({ big }) => (big ? rem('15px') : rem('12px'))};
  font-weight: 600;
`;

export const StyledConfirmation = styled.span`
  color: ${({ theme }) => theme.colors.cross.greenMint};
  font-size: ${rem('15px')};
  font-weight: 600;
`;

export const StyledFormMessage = styled.div`
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: ${rem('16px')};
  padding: ${rem('24px')};
  display: flex;
  justify-content: center;
`;
